module.exports = __webpack_public_path__ + "static/media/top-img_4_mob.d9796d03.png";